export default "__VITE_ASSET__Ir3puCJw__"